import { Component } from '@angular/core';

@Component({
  selector: 'ff-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
}



// WEBPACK FOOTER //
// /Users/manuel/Sites/doxasoft/fenyofarm/csemete/src/app/app.component.ts